import behaviourConstants from "@/constants/behaviourManagementConstants.js"

/**
 * @typedef {Object} CoreValueLookupEntry
 * @property {string} name
 * @property {string} category
 * @property {string} category_color
 * @property {string} indicator_color
 */

/**
 * Loads the full core values list (best-effort) and returns a `Map<string, entry>`
 * keyed by core value id. Used to fill in missing `coreValueName` / colors when
 * other endpoints (positive behaviours list, automated points settings) return
 * just the id.
 *
 * @param {import('vuex').Store} store
 * @returns {Promise<Map<string, CoreValueLookupEntry>>}
 */
export async function loadCoreValueLookup(store) {
  const lookup = new Map()
  try {
    const { rows } = await store.dispatch(
      "behaviourSettings/fetchCoreValuesList",
      {
        page: 1,
        perPage: behaviourConstants.CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE,
        search: "",
        statusFilter: "all"
      }
    )
    ;(rows || []).forEach((row) => {
      if (row?.id == null) return
      lookup.set(String(row.id), {
        name: String(row.name ?? ""),
        category: row.category || "",
        category_color: row.category_color || "",
        indicator_color: row.indicator_color || ""
      })
    })
  } catch {
    /* lookup is best-effort; callers fall back to whatever they already have */
  }
  return lookup
}
